import React from 'react'
import { styled } from '@mui/material/styles'
import { NoticeIcon } from '@/icon/menu'
import { Card } from '@mui/material'
import { boxShadow } from '@/constant'

export const BellWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: 'true' | 'false' }>(({ active }) => ({
  display: 'grid',
  position: 'relative',
  padding: '8px',
  backgroundColor: '#fff',
  borderRadius: '4px',
  placeItems: 'center',
  transition: 'all 0.2s ease-in-out',
  width: '32px',
  marginLeft: 'auto',
  '& > svg': {
    fontSize: '16px',
  },
  '&::after': {
    display: 'block',
    content: '\'\'',
    backgroundColor: '#FF665DFF',
    borderRadius: '25px',
    position: 'absolute',
    top: '8px',
    right: '12px',
    width: '0px',
    height: '0px',
    opacity: 0,
    transition: 'all 0.2s ease-in-out',
  },
  ...(active === 'true' && {
    '&::after': {
      display: 'block',
      content: '\'\'',
      backgroundColor: '#FF665DFF',
      position: 'absolute',
      top: '8px',
      right: '12px',
      borderRadius: '25px',
      width: '6px',
      height: '6px',
      opacity: 1,
      transition: 'all 0.2s ease-in-out',
    },
  }),
}))

export const ContentWrapper = styled('div')({
  position: 'absolute',
  right: '78px',
  top: '16px',
})

export const ContentCard = styled(Card)({
  backgroundColor: '#fff',
  backgroundImage: 'none',
  borderRadius: '4px',
  display: 'inline-flex',
  flexDirection: 'column',
  padding: '24px',
  width: '400px',
  gap: '16px',
})

export const NotificationIcon = ({ active }: { active: boolean }) => (
  <BellWrapper active={active ? 'true' : 'false'}>
    <NoticeIcon type={'default'} />
  </BellWrapper>
)

export const PlainCard = styled(Card)(() => ({
  flex: 1,
  marginBottom: '24px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  boxShadow,
  backgroundImage: 'none',
}))

export const Row = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
}))
